import { sendBookingDriverNotificationRequest } from "../../data/bookingDriverNotificationApi";

export async function sendBookingDriverNotificationUseCase(booking) {
  return await sendBookingDriverNotificationRequest({
    driverId: Number(booking.driver.driver_id),
    origin: booking.origin.name,
    destination: booking.destination.name,
    date: booking.date,
    time: booking.time.replace(/^00:/, "12:"),
    price: Number(booking.price),
  });
}
